

import { mapActions, mapGetters } from 'vuex'
import store from '../../common/mixins/store'
// import { LMap, LTileLayer, LMarker } from 'vue2-leaflet' // Removed - globally registered

export default {
  name: 'StoreDetail',
  // components: { // Removed - globally registered
  //   LMap,
  //   LTileLayer,
  //   LMarker
  // },
  mixins: [store],
  props: {
    storeDetailShow: {
      type: Boolean,
      default () {
        return false
      }
    },
    showStoreChangeBtn: {
      type: Boolean,
      default () {
        return false
      }
    },
    showFooterInfo: {
      type: Boolean,
      default () {
        return false
      }
    },
    showDetailsBox: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      visible: false
      // map: null, // No longer needed, handled by vue2-leaflet
      // marker: null // No longer needed, handled by vue2-leaflet
    }
  },
  computed: {
    ...mapGetters(['currentStore', 'storeInfo']),
    mapPointer () {
      if (this.storeInfo && this.storeInfo.lat && this.storeInfo.lon) {
        return { lat: parseFloat(this.storeInfo.lat), lng: parseFloat(this.storeInfo.lon) }
      }
      return null
    }
  },
  watch: {
    storeDetailShow (newValue) {
      this.visible = newValue
    }
    // mapPointer watch handler is no longer needed, vue2-leaflet handles reactivity
  },
  mounted () {
    if (this.storeDetailShow) {
      this.visible = true
    }
    if (this.currentStore) {
      this.setCurrentStoreData({ store_id: this.currentStore.id })
    }
    // No manual Leaflet initialization needed here
  },
  beforeDestroy () {
    // No manual map cleanup needed, vue2-leaflet handles this
  },
  methods: {
    ...mapActions(['getStores', 'setCurrentStore', 'setCurrentStoreData']),
    // updateMarker is no longer needed
    async removeCurrentStore () {
      this.$emit('update:storeDetailShow', false)
      await this.setCurrentStore(null)
      this.$bvModal.show('store-modal')
    }
  }
}
